module.exports = __webpack_public_path__ + "img/pulido_fino.3ef132de.png";